export default __webpack_public_path__ + "47c979e9e773a505ba7740307bc8e05d.png";